module.exports = __webpack_public_path__ + "6b09b73e71562a0feb784f72efcc20b1.jpg";